import React from "react";

type Props = {
  drawerOpen: boolean;
  setDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const TopNavbar: React.FC<Props> = ({ drawerOpen, setDrawerOpen }) => {
  return (
    <header className="sticky top-0 z-[1000] bg-white border-b border-gray-200">
      <div className="px-6 h-14 flex items-center gap-4">
        <button className="text-xl text-gray-600" onClick={() => setDrawerOpen((v) => !v)}>
          ☰
        </button>

        <div className="flex-1">
          <h2 className="text-lg font-semibold text-gray-800">Dashboard Configuration</h2>
          <p className="text-xs text-gray-500">Manage widget permissions across all user roles</p>
        </div>
      </div>
    </header>
  );
};

export default TopNavbar;
